import { useMediaQuery } from "@mui/material";
import { useEffect } from "react";
import { CSSProperties } from "styled-components";
export const DashboardWrapper = { margin: "0px 20px", height: "93vh" };

export const DashboardTitles = {
  fontWeight: "600",
  fontSize: "24px",
  fontFamily: "lato",
  display: "inline-block",
};
export const DashboardSubTitles = {
  fontWeight: "600",
  fontSize: "14px",
  fontFamily: "lato",
  display: "inline-block",
  color: "#0D47A1",
  textDecoration: "none",
};
export const DashboardWidgetWrapper = {
  marginTop: "16px",
  display: "flex",
  flexDirection: "column",
  paddingBottom: "16px",
};
export const DashboardContentWrapper = {
  display: "flex",
  width: "100%",
  alignItems: "center",
  marginBottom: "16px",
};

export const ArrowForwardStyle = {
  fontSize: "15px",
  marginBottom: "-3px",
  color: "#0D47A1",
};

export const SubtitleText = {
  fontFamily: "lato",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "24px",
  color: "#424242",
  textAlign: "center",
  alignItems: "center",
  letterSpacing: "0.15px",
};

export const SubtitleTextBox = { maxWidth: "232px", marginTop: "26px" };

export const ValueText = {
  fontFamily: "lato",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "60px",
  lineHeight: "72px",
  textAlign: "center",
  letterSpacing: "-0.5px",
};

export const ValueTextBox = {
  position: "relative",
  left: "0px",
  top: "120px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

export const ValueContainer = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const TitleText = {
  fontFamily: "lato",
  fontSize: "16px",
  fontWeight: "600",
};

export const TitleBox = {
  margin: "0 8px",
};

export const AggregatedViewCard = {
  borderRadius: "8px",
  border: "1px solid lightgrey",
  padding: "18px",
  height: "395px",
};

export const ContentContainer = {
  display: "flex",
  alignItems: "start",
  position: "relative",
};

export const TitleContainer = {
  position: "absolute",
  right: "0px",
  cursor: "pointer",
};

export const WidgetIcon = { marginTop: "3px" };

export const SharePointText = { pointerEvents: "none" };

export const SkeletonBar = {
  borderRadius: "10px",
  height: 8,
  bgcolor: "#012b49",
  marginTop: "10px",
};

export const SkeletonBarCircular = {
  borderRadius: 70,
  height: 70,
  width: 70,
  marginLeft: 10,
};

export const SkeletonBarContainer = {
  direction: "column",
  alignItems: "center",
  justifyContent: "center",
};

export const optionStyles = {
  cursor: "pointer",
  display: "flex",
  justifyContent: "flex-start",
  padding: "0px 20px",
  color: "#FF6C37",
  fontSize: "18px",
  border: "1px solid #eeeeee",
  borderRadius: "4px",
  alignItems: "center",
  height: "50px",
  boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.25)",
  "&:hover": {
    background: "#FF6C3714",
    border: "1px solid #FF6C37",
    "& img.leftArrow": {
      animation: "slideRightToLeft 0.4s infinite alternate",
    },
  },
  "@keyframes slideRightToLeft": {
    "0%": {
      transform: "translateX(50%)",
    },
    "100%": {
      transform: "translateX(0%)",
    },
  },
};
export const iconStyles = {
  margin: "0px 10px",
  width: "38px",
  height: "34px",
};
export const GridContainerStyles = {
  marginTop: "10px",
  borderRadius: "8px",
};
export const AccordionStyles: CSSProperties = {
  padding: "14px",
  borderRadius: "8px",
  width: "420px",
  position: "fixed",
  overflow: "auto",
  top: "75px",
  maxHeight: "calc(100% - 120px)",
  right: "0px",
};
export const closeBtn: CSSProperties = {
  position: "absolute",
  top: 10,
  right: 10,
  cursor: "pointer",
};
export const guideTitle: CSSProperties = {
  fontSize: "32px",
  color: "#0275C4",
  lineHeight: "36px",
  marginBottom: "20px",
};
export const guideTitleText: CSSProperties = {
  fontWeight: "700",
};
export const guideInfo: CSSProperties = {
  fontSize: "16px",
  color: "#FF6127",
  fontStyle: "italic",
};
export const guideSubtitle: CSSProperties = {
  fontSize: "20px",
  paddingTop: "10px",
};
